import moment from 'moment';
import { db } from './../config/Fire';
import * as Constants from './../constants/nodes_database';

export const SET_NEXT_RESERVATIONS = 'SET_NEXT_RESERVATIONS';

const setNextReservations = payload => ({ type: SET_NEXT_RESERVATIONS, payload });

export const setNextReservationsByRestaurantId = payload => {
    return dispatch => {
        return db.ref(`${Constants.RESERVATIONS}`).orderByChild("restoId").equalTo(payload).on("value", function(snapshot) {
            if(snapshot.exists() && snapshot.val() !== null) {
                const reservations = snapshot.val() ? snapshot.val() : {};
                const nextReservations = {};
                const todayDate = moment(new Date()).format('DD/MM/YYYY');
                const previusTodayDate = moment(new Date()).subtract(3, 'd').format('DD/MM/YYYY');
                const todayDateToCompare = moment(previusTodayDate, 'DD/MM/YYYY');
                //console.log("reservations" + JSON.stringify(reservations));
                for(let index in reservations) {
                    const reserve = reservations[index];
                    const reserveDate = moment(reserve.date, 'DD/MM/YYYY');
                    if(reserveDate.isSameOrAfter(todayDateToCompare)) {
                        nextReservations[reserve.reservationId] = reserve;
                    }
                }
                //console.log("nextReservations" + JSON.stringify(nextReservations));
                dispatch(setNextReservations(nextReservations));
            } else {
                const nextReservations = {};
                dispatch(setNextReservations(nextReservations));
            }
        });
    };
};